import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { isEmpty, isUndefined } from "lodash";
import CreditInfo from "@components/CreditInfo/CreditInfo";
import { history } from "@helpers/history";
import { isObjEmpty } from "@helpers/utils";


const BORDER_TOP_COLOR = "#d7de00";

function CreditosHipotecarios(props) {
  const {
    match: { params },
  } = props;
  const [idCredito, setIdCredito] = useState("");
  const [credit, setCredit] = useState({});

  const { rutas } = useSelector(({ Base }) => Base.ContenidoCMS);
  const { creditosHipotecarios } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito.AhorroYCredito
  );

  useEffect(() => {
    setIdCredito(params?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const defRoute = rutas?.filter(
      (route) => route?.name === "Creditos Hipotecarios Listado"
    );

    const prevRoute = defRoute.map((route) => {
      return {
        url: route.url.replace("/:id", ""),
        text: route.h1,
      };
    });

    if (!isEmpty(idCredito) && !isEmpty(creditosHipotecarios)) {
      let promise = new Promise((resolve, reject) => {
        let normalizeCredits = [];
        let resMatch = {};
        if (!isEmpty(creditosHipotecarios?.aCCreditosHipotecarios)) {
          normalizeCredits = creditosHipotecarios.aCCreditosHipotecarios.map(
            (credito) => ({
              ...credito,
              idCredito: credito.idCredito.toLowerCase().replaceAll(" ", "-"),
              rutaPrevia: prevRoute,
            })
          );
          resMatch =
            normalizeCredits &&
            normalizeCredits.filter(
              (credito) => credito.idCredito === idCredito
            )[0];
        }
        if (
          !isEmpty(creditosHipotecarios?.aCCreditosHipotecarios) &&
          !isEmpty(creditosHipotecarios?.aCBotonSoliciteSuCredito)
        ) {
          resMatch = {
            ...resMatch,
            btnSolicite: {
              images: creditosHipotecarios.aCBotonSoliciteSuCredito[0],
              url: resMatch?.urlFormularioSoliciteCredito?.url,
              alt: resMatch?.urlFormularioSoliciteCredito?.text,
            },
          };
        }
        resolve(resMatch);
      });

      promise.then((res) =>
        !isUndefined(res.btnSolicite.url) && !isEmpty(res)
          ? setCredit({
              id: res.idCredito,
              title: res.titulo,
              description: res.descripcion?.html,
              details: res.bag?.contentItems,
              btnSolicite: res.btnSolicite,
              btnCalcule: {},
              prevRoute: res.rutaPrevia,
            })
          : isObjEmpty(credit) && history.push('/no-encontrado')
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [creditosHipotecarios, idCredito]);

  return (
    <>
      {!isEmpty(credit) && (
        <CreditInfo credito={credit} borderTopColor={BORDER_TOP_COLOR} />
      )}
    </>
  );
}

export default CreditosHipotecarios;
